"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PageConstants = require("./PageConstants");

var _UIAbstractPageTemplate = _interopRequireDefault(require("./UIAbstractPageTemplate"));

var _UIMain = _interopRequireDefault(require("../layout/UIMain"));

var _UIScrollingColumn = _interopRequireDefault(require("../layout/UIScrollingColumn"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _sizes = require("HubStyleTokens/sizes");

var _ShareScrollElement = _interopRequireDefault(require("../decorators/ShareScrollElement"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100%;\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MainInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIEditorPage__MainInnerWrapper",
  componentId: "o8x20r-0"
})(_templateObject(), function (props) {
  return !props.mainSectionFlush && props.hasScrolling && _sizes.LAYOUT_EDITOR_PADDING;
});

function renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling) {
  if (!sidebarComponent) return null;
  var RenderedSidebar = hasScrolling ? _UIScrollingColumn.default : 'div';
  var scrollableProps = hasScrolling ? {
    scrollElementRef: sidebarScrollElementRef
  } : null;
  return _react.default.createElement(RenderedSidebar, (0, _extends2.default)({}, scrollableProps, {
    className: "private-editor__sidebar",
    style: {
      backgroundColor: sidebarBackgroundColor
    }
  }), CustomRenderer.render(sidebarComponent));
}

var UIEditorPage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIEditorPage, _Component);

  function UIEditorPage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIEditorPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIEditorPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.MainSection = function (props) {
      var _this$props = _this.props,
          mainSectionFlush = _this$props.mainSectionFlush,
          hasScrolling = _this$props.hasScrolling,
          Overhang = _this$props.Overhang,
          scrollDirection = _this$props.scrollDirection,
          scrollElementRef = _this$props.scrollElementRef,
          sidebarBackgroundColor = _this$props.sidebarBackgroundColor,
          sidebarScrollElementRef = _this$props.sidebarScrollElementRef;
      var children = props.children,
          mainSectionBackgroundColor = props.mainSectionBackgroundColor,
          mainSectionStyle = props.mainSectionStyle,
          sidebarComponent = props.sidebarComponent;
      var RenderedMain = hasScrolling ? _UIScrollingColumn.default : _UIMain.default;
      var computedFlush = hasScrolling ? true : mainSectionFlush;
      var scrollableProps = hasScrolling ? {
        Overhang: Overhang,
        role: 'main',
        scrollDirection: scrollDirection,
        scrollElementRef: scrollElementRef
      } : null;
      return _react.default.createElement("div", {
        className: "private-editor__inner"
      }, renderEditorSidebar(sidebarComponent, sidebarBackgroundColor, sidebarScrollElementRef, hasScrolling), _react.default.createElement("div", {
        className: (0, _classnames.default)('private-editor__canvas', {
          'private-editor__canvas--flush': computedFlush
        }),
        style: (0, _extends2.default)({}, {
          backgroundColor: mainSectionBackgroundColor
        }, mainSectionStyle)
      }, _react.default.createElement(RenderedMain, (0, _extends2.default)({
        className: "private-editor__main",
        flush: true
      }, scrollableProps), _react.default.createElement(MainInnerWrapper, {
        hasScrolling: hasScrolling,
        mainSectionFlush: mainSectionFlush
      }, children))));
    };

    return _this;
  }

  (0, _createClass2.default)(UIEditorPage, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          __hasScrolling = _this$props2.hasScrolling,
          headerComponent = _this$props2.headerComponent,
          mainBackgroundColor = _this$props2.mainBackgroundColor,
          __mainSectionFlush = _this$props2.mainSectionFlush,
          mainSectionStyle = _this$props2.mainSectionStyle,
          __Overhang = _this$props2.Overhang,
          __scrollDirection = _this$props2.scrollDirection,
          __scrollElementRef = _this$props2.scrollElementRef,
          __sidebarBackgroundColor = _this$props2.sidebarBackgroundColor,
          sidebarComponent = _this$props2.sidebarComponent,
          __sidebarScrollElementRef = _this$props2.sidebarScrollElementRef,
          tabs = _this$props2.tabs,
          title = _this$props2.title,
          use = _this$props2.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "hasScrolling", "headerComponent", "mainBackgroundColor", "mainSectionFlush", "mainSectionStyle", "Overhang", "scrollDirection", "scrollElementRef", "sidebarBackgroundColor", "sidebarComponent", "sidebarScrollElementRef", "tabs", "title", "use"]);
      var mainPanelBackgroundColor = use === 'dark' ? _PageConstants.CARD_BACKGROUND : mainBackgroundColor;
      return _react.default.createElement(_UIAbstractPageTemplate.default, (0, _extends2.default)({}, rest, {
        bodyClassName: "space-sword--editor",
        className: (0, _classnames.default)('private-editor', className),
        contentAreaFlush: true,
        headerComponent: headerComponent,
        horizontalDivider: true,
        MainSection: this.MainSection,
        mainSectionBackgroundColor: mainPanelBackgroundColor,
        mainSectionStyle: mainSectionStyle,
        pageLayout: "full-width",
        sidebarComponent: sidebarComponent,
        tabs: tabs,
        title: title
      }), children);
    }
  }]);
  return UIEditorPage;
}(_react.Component);

UIEditorPage.displayName = 'UIEditorPage';
UIEditorPage.propTypes = {
  children: _propTypes.default.node,
  hasScrolling: _propTypes.default.bool.isRequired,
  headerComponent: CustomRenderer.propType,
  mainBackgroundColor: _propTypes.default.string,
  mainSectionFlush: _propTypes.default.bool,
  mainSectionStyle: _propTypes.default.object,
  Overhang: _UIScrollingColumn.default.propTypes.Overhang,
  pageLayout: _propTypes.default.oneOf(Object.keys(_PageConstants.LAYOUT_CLASSES)),
  scrollDirection: _UIScrollingColumn.default.propTypes.scrollDirection,
  scrollElementRef: _refObject.default.isRequired,
  sidebarScrollElementRef: _refObject.default,
  sidebarBackgroundColor: _propTypes.default.string,
  sidebarComponent: CustomRenderer.propType,
  tabs: _propTypes.default.node,
  title: _propTypes.default.node,
  use: _propTypes.default.oneOf(['default', 'dark'])
};
UIEditorPage.defaultProps = {
  hasScrolling: true,
  mainSectionFlush: false,
  sidebarBackgroundColor: _PageConstants.CARD_BACKGROUND,
  scrollDirection: _UIScrollingColumn.default.defaultProps.scrollDirection
};

var _default = (0, _ShareScrollElement.default)(UIEditorPage);

exports.default = _default;
module.exports = exports.default;